module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "front-index",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('frontMenu'), _vm._v(" "), _c('div', {
    staticClass: "page-right"
  }, [_c('div', {
    staticClass: "page-right-top"
  }, [_c('readInfo', {
    staticClass: "align"
  }), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "menu-align": "start"
    }
  }, [_c('z-lazyImg', {
    staticClass: "user-photo-nav",
    attrs: {
      "id": "img",
      "src": _vm.userInfo.userLogo
    }
  }), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.code(2000)) ? _c('el-dropdown-item', [_c('div', {
    on: {
      "click": _vm.goSystem
    }
  }, [_vm._v("系统管理")])]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', [_c('div', {
    on: {
      "click": _vm.changeImg
    }
  }, [_vm._v("上传头像")])]), _vm._v(" "), _c('el-dropdown-item', [_c('div', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('upAvatar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openAvatar),
      expression: "openAvatar"
    }],
    attrs: {
      "img": _vm.userInfo.userLogo
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-01761086!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/Index.vue
// module id = 680
// module chunks = 1